var _circle, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNextiraLoadingRing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 32,
    strokeWidth: 6,
    stroke: "#00ffab",
    strokeDasharray: "50.26548245743669 50.26548245743669",
    fill: "none",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    dur: "1s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 50 50;360 50 50"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 23,
    strokeWidth: 6,
    stroke: "#4716c8",
    strokeDasharray: "36.12831551628262 36.12831551628262",
    strokeDashoffset: 36.12831551628262,
    fill: "none",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    dur: "1s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 50 50;-360 50 50"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextiraLoadingRing);
export default __webpack_public_path__ + "static/media/nextira_loading_ring.a4aa4d24.svg";
export { ForwardRef as ReactComponent };